export const PageType = {
  DASHBOARD: 'dashboard',
  LIST: 'list',
  OVERVIEW: 'overview',
};
